import HTTP from '../HTTP';

const SOCIETES_URL = 'societes';
const DEVIS_URL = 'devis';
const PRODUITS_URL = 'produits';

export async function getSocieteUser(idSociete) {
  try {
    if (idSociete) return (await HTTP.get(SOCIETES_URL + '/getSocieteById/' + idSociete)).data.result;
    return (await HTTP.get(SOCIETES_URL + '/getSocieteByNoId')).data.result.items[0];
  } catch (e) {
    throw e;
  }
}

export async function ping() {
  try {
    return await HTTP.get(DEVIS_URL);
  } catch (e) {
    throw e;
  }
}

export async function GetDevisById(id) {
  try {
    return await HTTP.get(DEVIS_URL + '/' + id);
  } catch (e) {
    throw e;
  }
}

export async function createDevisOpp(idOpp, content) {
  try {
    return await HTTP.post(DEVIS_URL + '/createDevisOpp', {
      content: JSON.stringify(content),
      idOpp,
    });
  } catch (e) {
    throw e;
  }
}

export async function updateDevisOpp(idOpp, content) {
  try {
    return await HTTP.put(DEVIS_URL + '/updateDevisOpp', {
      content: JSON.stringify(content),
      idOpp,
    });
  } catch (e) {
    throw e;
  }
}

export async function getProduitAssocie(id) {
  try {
    return await HTTP.get(PRODUITS_URL + '/GetAsync/' + id);
  } catch (e) {
    throw e;
  }
}

export async function getProduitLocation(id) {
  try {
    return await HTTP.get(PRODUITS_URL + '/ProduitLocation/GetAsync/' + id);
  } catch (e) {
    throw e;
  }
}

export async function getAllProduitsFace(query) {
  try {
    return await HTTP.post(PRODUITS_URL + '/PGetAllAsync', query);
  } catch (e) {
    throw e;
  }
}

export async function getAllProduitLocations(query) {
  try {
    return await HTTP.post(PRODUITS_URL + '/PGetAllLocationAsync', query);
  } catch (e) {
    throw e;
  }
}

export async function Brouillon2Enregistre(id) {
  try {
    return await HTTP.post(DEVIS_URL + '/Brouillon2Enregistre/' + id);
  } catch (e) {
    throw e;
  }
}

export async function DeleteDevis(id) {
  try {
    const response = await HTTP.delete(DEVIS_URL + '/' + id);
    return response;
  } catch (e) {
    throw e;
  }
}



// WEBPACK FOOTER //
// ./src/api/devis/index.js